import { isMobile } from "../Utils/variables_functions";

export default function Footer() {
    document.addEventListener('DOMContentLoaded', function() {
        autoDate();
        changeBtnText();
        backToTopBtn();
    })
    
    // functions
    function autoDate() {
        const currentYear = new Date().getFullYear()
        const yearElement = document.querySelector('.auto--year')
        yearElement.innerHTML = currentYear
    }

    function changeBtnText() {
        document.querySelectorAll('#footer .btn-secondary').forEach(btn => {
            const textEl = btn.querySelector('.btn-text');
            const hoverText = btn.getAttribute('data-hover');

            if (!textEl || !hoverText) return;

            const originalText = textEl.textContent;

            btn.addEventListener('mouseenter', () => {
                textEl.textContent = hoverText;
            });

            btn.addEventListener('mouseleave', () => {
                textEl.textContent = originalText;
            });
        });
    }

    function backToTopBtn() {
        let backToTopBtn = document.getElementById('backToTop');

        backToTopBtn.addEventListener('click', function() {
            if (!isMobile) {
                window.lenis.scrollTo(0, 0, { duration: 1.2, easing: 'easeInOutCubic' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        })
    }
}